import { GraphicModeOption } from '@/model/CommonModel';
import { Menu, MenuProps } from 'antd';
import { ItemType } from 'antd/es/menu/interface';
import cx from 'classnames';
import React, { FC } from 'react';
import styles from './graphicModeMenu.module.scss';

type Props = {
	mode: number;
	options: GraphicModeOption[];
	disabled?: boolean;
	showArrow?: boolean;
	onChangeMode: (mode: number) => void;
};

export const GraphicModeMenu: FC<Props> = ({ disabled, options, mode, showArrow, onChangeMode }) => {
	const items: MenuProps['items'] = options.map<ItemType>((option: GraphicModeOption) => ({
		className: styles.graphicsModeMenuItem,
		key: option.value,
		title: option.text,
		disabled: disabled || !option.hasPermission,
		label: (
			<>
				<span className={styles.icon}>{option.value === mode ? option.SelectedIcon : option.UnSelectedIcon}</span>
				{option.text}
			</>
		),
	}));

	const handleOnClick: MenuProps['onClick'] = e => {
		const { key } = e;
		if (key === mode.toString()) return;

		onChangeMode(Number(key));
	};

	return (
		<div>
			<Menu
				className={cx(styles.menu, { [styles.graphicsModeMenu]: showArrow })}
				id='graphicsModeMenu'
				items={items}
				mode='horizontal'
				onClick={handleOnClick}
				selectedKeys={[mode.toString()]}
				disabledOverflow={true}
			/>
		</div>
	);
};
